import Hero from '../hero/Hero'
import React from "react"

export default (props) => (
	<Hero bckgrdImage={props.bckgrdImage}>
	 	 <h1 className="headline"><span>VASCEPA is available at a</span> <span class="bold700">lower out-of-pocket cost than generic</span> <span>icosapent ethyl for most patients<sup>1*</sup></span></h1>
	</Hero>
)